import React, {useState, useCallback, useEffect, useMemo} from 'react'
import SMCTextInput from '../../components/Simple/SMCTextInput';
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModal from '../../components/core/SMCModal';
import {ObjectTypes} from '../../api/consts';
import Api from '../../api/SMPFetchHelper';
import SMCTable from '../../components/core/SMCTable/SMCTable';
import SMCLabel from '../../components/Simple/SMCLabel';
import {PlanGetListSchema, PlanFilterSchema, PlanFeatureModes} from '../../api/DBSchema/Plan';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useSMCErrorHandler} from '../../utils/errorUtils';

function SetPlanModal({
    isOpen,
    onRequestClose,
    onSuccess,
    onError,
    hideDisabled
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const planTableColumns = useMemo(() => ([
        { id: 'name',        accessor: PlanGetListSchema.name,        header: t('SMP.NAME'),        width: 130 },
        { id: 'description', accessor: PlanGetListSchema.description, header: t('SMP.DESCRIPTION'), width: 130 }
    ]), [t]);

    const [selectedObjects, setSelectedObjects] = useState([]);
    const [isTableDataLoading, setIsTableDataLoading] = useState(false);
    const [planTableData, setPlanTableData] = useState([]);
    const [planSeachText, setPlanSeachText] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);

    const handleTableSelect = useCallback((selectedObjects) => {
        if (selectedObjects.length <= 1) {
            setSelectedObjects(selectedObjects);
        }
        // If selected another, replace the originally selected with the new one
        else if (selectedObjects.length === 2) {
            setSelectedObjects([selectedObjects[1]])
        }
    }, []);

    const loadData = useCallback(() => {
        setIsTableDataLoading(true);
        Api.fetchObjectList(ObjectTypes.PLAN, 0, null, null, null, {[PlanFilterSchema.freeTextSearch]: {value: planSeachText}})
        .then((resp) => {
            if (hideDisabled && Array.isArray(resp.data.data)) {
                setPlanTableData(resp.data.data.filter(plan => plan[PlanGetListSchema.enabled] === PlanFeatureModes.enabled));
            } else {
                setPlanTableData(resp.data.data);
            }
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            setErrorMessage(errorMessage);
        })
        .finally(() => {
            setIsTableDataLoading(false);
        });
    }, [planSeachText, hideDisabled, getErrorMessage]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleSetPlan = useCallback(() => {
        if (selectedObjects.length === 1) {
            Api.fetchSingleObject(ObjectTypes.PLAN, selectedObjects[0])
            .then(resp => {
                onSuccess(resp.data.data.plan);
            })
            .catch(e => {
                console.log(e.message);
                onError && onError('SMP.GATEWAYS.CHANGE_PLAN.ERROR.FETCHING_SELECTED');
            })
        }
    }, [selectedObjects, onError, onSuccess]);

    return (
        <SMCModal
            title="Set plan"
            height={620}
            width={690}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            errorMessage={errorMessage}
            reloadData={loadData}
        >
            <SMCModalBody>
                <SMCLabel bold>{t('SMC_GATEWAY_SEARCH_PLAN')}</SMCLabel>
                <SMCTextInput
                    suffixIcon="search"
                    allowClearAll
                    placeholder={t('SMP.SEARCH')}
                    value={planSeachText}
                    onChange={e => setPlanSeachText(e.target.value)}
                />
                <SMCTable
                    loading={isTableDataLoading}
                    content={planTableData}
                    columns={planTableColumns}
                    width={630}
                    height={350}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={handleTableSelect}
                    rowIdSelector={(obj) => obj[PlanGetListSchema.name]}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={handleSetPlan} disabled={selectedObjects.length === 0}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    Set plan
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default SetPlanModal;